// extracted by mini-css-extract-plugin
export default {"Overlay_0":"AutocompleteSuggestions-module__Overlay_0--QuLJW","suggestion":"AutocompleteSuggestions-module__suggestion--qvk1X"};